function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FFF0F0",
    style: {
      fill: "#FFF0F0",
      fill: "color(display-p3 1.0000 0.9429 0.9429)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.5C18.5 15.2033 18.588 14.9133 18.7528 14.6666C18.9176 14.42 19.1519 14.2277 19.426 14.1142C19.7001 14.0006 20.0017 13.9709 20.2926 14.0288C20.5836 14.0867 20.8509 14.2296 21.0607 14.4393C21.2704 14.6491 21.4133 14.9164 21.4712 15.2074C21.5291 15.4983 21.4994 15.7999 21.3858 16.074C21.2723 16.3481 21.08 16.5824 20.8334 16.7472C20.5867 16.912 20.2967 17 20 17C19.6022 17 19.2206 16.842 18.9393 16.5607C18.658 16.2794 18.5 15.8978 18.5 15.5ZM14 15.5C14 13.9087 14.6321 12.3826 15.7574 11.2574C16.8826 10.1321 18.4087 9.5 20 9.5C21.5913 9.5 23.1174 10.1321 24.2426 11.2574C25.3679 12.3826 26 13.9087 26 15.5C26 21.1203 20.6019 24.2694 20.375 24.4016C20.2617 24.4663 20.1334 24.5004 20.0028 24.5004C19.8723 24.5004 19.744 24.4663 19.6306 24.4016C19.3981 24.2694 14 21.125 14 15.5ZM15.5 15.5C15.5 19.4563 18.86 22.0822 20 22.8594C21.1391 22.0831 24.5 19.4563 24.5 15.5C24.5 14.3065 24.0259 13.1619 23.182 12.318C22.3381 11.4741 21.1935 11 20 11C18.8065 11 17.6619 11.4741 16.818 12.318C15.9741 13.1619 15.5 14.3065 15.5 15.5ZM27.0097 21.8403C26.8251 21.7793 26.624 21.7924 26.4489 21.8768C26.2738 21.9612 26.1382 22.1102 26.0709 22.2926C26.0035 22.475 26.0096 22.6764 26.0879 22.8543C26.1661 23.0323 26.3104 23.1729 26.4903 23.2466C28.0381 23.8194 29 24.5863 29 25.25C29 26.5025 25.5763 28.25 20 28.25C14.4237 28.25 11 26.5025 11 25.25C11 24.5863 11.9619 23.8194 13.5097 23.2475C13.6896 23.1739 13.8339 23.0332 13.9121 22.8553C13.9904 22.6773 13.9965 22.4759 13.9291 22.2935C13.8618 22.1112 13.7262 21.9621 13.5511 21.8777C13.376 21.7933 13.1749 21.7803 12.9903 21.8412C10.7394 22.6709 9.5 23.8822 9.5 25.25C9.5 28.1731 14.9103 29.75 20 29.75C25.0897 29.75 30.5 28.1731 30.5 25.25C30.5 23.8822 29.2606 22.6709 27.0097 21.8403Z",
    fill: "#FF7777",
    style: {
      fill: "#FF7777",
      fill: "color(display-p3 1.0000 0.4673 0.4673)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/location-red.1480c1f515b0a7a7e8bae2ba402f6a6a.svg";
export { ForwardRef as ReactComponent };